import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-idle-timeout-dialog',
  templateUrl: './idle-timeout-dialog.component.html',
  styleUrls: ['./idle-timeout-dialog.component.css']
})
export class IdleTimeoutDialogComponent {
  public timeLeft: number;

  constructor (private dialogRef: MatDialogRef<IdleTimeoutDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any)
    {
      this.timeLeft = data.timeLeft;
      this.startcountdown();
    }
    startcountdown(){
       const intervalId = setInterval(() => {
         this.timeLeft--;
         if(this.timeLeft<=0)
         {
          clearInterval(intervalId);
          this.dialogRef.close('logout');
         }
       }, 1000);
    }

    onCancel(): void
    {
      this.dialogRef.close('cancel');
    }

    onLogout(): void
    {
      this.dialogRef.close('logout');
    }

}
